import { AxiosPromise } from "axios";

import api from "../config/api-config";

export function getReceiving(): AxiosPromise {
  return api.get("v1/receiving-sector", {});
}

export function getReceivingByIdStore(id: number): AxiosPromise {
  return api.get("v1/receiving-sector/stores/" + id, {});
}

export function postInventory(obj: any): AxiosPromise {
  return api.post("v1/receiving-sector/", obj, {});
}

export function putInventory(obj: any, idStore: any): AxiosPromise {
  return api.put("v1/receiving-sector", obj, {});
}

export function deleteInventory(id: number): AxiosPromise {
  return api.delete("v1/receiving-sector/" + id);
}

export function getReceivingHistoric(): AxiosPromise {
  return api.get("v1/receiving-sector/logs", {});
}

export function getReceivingStructure(): AxiosPromise {
  return api.get("v1/receiving-sector/structure");
}

export function getSupplierGP(storeId: any): AxiosPromise {
  return api.get("v1/receiving-sector/suppliers/stores/" + storeId, {});
}

export function postSupplierGP(obj: any): AxiosPromise {
  return api.post("v1/receiving-sector/suppliers", obj, {});
}

export function putSupplierGP(obj: any): AxiosPromise {
  return api.put("v1/receiving-sector/suppliers", obj, {});
}

export function deleteSupplierGP(id: any): AxiosPromise {
  return api.delete("v1/receiving-sector/suppliers/" + id, {});
}

export function getGPSupplier(storeID: any, supplierID: any): AxiosPromise {
  return api.get(
    "v1/receiving-sector/suppliers/" +
      supplierID +
      "/stores/" +
      storeID +
      "/management",
    {}
  );
}
export default {
  getReceiving,
  postInventory,
  putInventory,
  getReceivingHistoric,
  getReceivingByIdStore,
  deleteInventory,
  getReceivingStructure,
  getSupplierGP,
  postSupplierGP,
  putSupplierGP,
  deleteSupplierGP,
  getGPSupplier,
};
